import script from "./BaseFilePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilePreview.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilePreview.vue?vue&type=style&index=0&id=ae9f03ba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae9f03ba"]])

export default __exports__